import { AlertCircle, CheckCircle2, CreditCard } from "lucide-react";

import { Button } from "~/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "~/components/ui/card";
import { Spinner } from "~/components/ui/spinner";

export function ConfirmSubscriptionStep({
  isAbandonedOnboarding,
  isCreating,
  onSubscribe,
}: {
  isAbandonedOnboarding: boolean;
  isCreating: boolean;
  onSubscribe: () => void;
}) {
  const subscribeButtonText = isAbandonedOnboarding
    ? "Complete Setup & Subscribe"
    : "Subscribe & Continue";
  const cardTitle = isAbandonedOnboarding
    ? "Finish Your Setup"
    : "Confirm Subscription";

  return (
    <Card className="mx-auto max-w-lg">
      <CardHeader className="text-center">
        {isAbandonedOnboarding && (
          <div className="bg-warning/10 text-warning dark:bg-warning/10 dark:text-warning mx-auto mb-4 flex items-center gap-2 rounded-lg px-4 py-2">
            <AlertCircle className="size-4 shrink-0" />
            <span className="text-sm">
              Complete your setup to activate POS access
            </span>
          </div>
        )}
        <div className="bg-primary/10 mx-auto mb-4 flex size-16 items-center justify-center rounded-full">
          <CreditCard className="text-primary size-8" />
        </div>
        <CardTitle className="h2">{cardTitle}</CardTitle>
        <CardDescription className="body">
          Subscribe to activate your POS system.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Button
          className="w-full"
          disabled={isCreating}
          onClick={onSubscribe}
          size="lg"
        >
          {isCreating ? (
            <>
              <Spinner className="mr-2 size-4" />
              Creating subscription...
            </>
          ) : (
            <>
              <CheckCircle2 className="mr-2 size-4" />
              {subscribeButtonText}
            </>
          )}
        </Button>
      </CardContent>
    </Card>
  );
}
